import { PencilIcon } from '@ui/kit/icons';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const okLabelCls = "_ibqo1m432l2";
const firstInteractionConfirmConfig = {
  heading: "Lav din egen version af forløbet",
  body: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("p", {
      children: "Tilpas forl\xF8bet ved at frav\xE6lge det indhold, du ikke skal bruge. Du kan altid g\xE5 tilbage til det originale forl\xF8b."
    }), /*#__PURE__*/jsx("p", {
      children: "N\xE5r du har lavet din egen version, kan du gemme og dele den med dine elever."
    })]
  }),
  labels: {
    ok: /*#__PURE__*/jsxs("span", {
      className: okLabelCls,
      children: [/*#__PURE__*/jsx(PencilIcon, {
        height: "14"
      }), "Tilpas forl\xF8b"]
    })
  }
};

export { firstInteractionConfirmConfig };
import "./first-interaction.linaria.module.css";
//# sourceMappingURL=first-interaction.js.map
